import React from "react";
import { ReactComponent as LowerBannerSVG } from "../assets/lower-banner.svg";
const AnimWebBanner = (props) => {
  return <LowerBannerSVG />;
};

export default AnimWebBanner;
